module.exports = __webpack_public_path__ + "img/yml_gallery15.f4ec0773.jpg";